import SharedCustomers from "../classes/SharedCustomers";

const defaultState = () => ({
  data: [],
  filter_string: ""
});

const state = defaultState();

// getters
const getters = {
  customers: () => {
    if (!state.filter_string) {
      return state.data;
    }
    let lc_fs = state.filter_string.toLowerCase();
    return state.data.filter(
      v =>
        v.name.toLowerCase().includes(lc_fs) ||
        (v._embedded.sharedAmocrm || []).filter(
          vv =>
            vv.domain.toLowerCase().includes(lc_fs) ||
            vv.login.toLowerCase().includes(lc_fs) ||
            String(vv.account_id)
              .toLowerCase()
              .includes(lc_fs)
        ).length
    );
  },
  filter_string: () => state.filter_string
};

// actions
const actions = {
  shared_customers_list(state, data) {
    state.commit("setData", data);
  }
};

// mutations
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  setData(state, data) {
    state.data = SharedCustomers.getSelfList(data);
  },
  filter_string(state, data) {
    state.filter_string = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
